import React, { useState } from 'react'
import Sheet from '@mui/joy/Sheet'
import { ColorButton } from './ui/ColorButton'

export const CanvasGrid = ({ canvas, onColorChange }) => {
    const [fillColor, setFillColor] = useState(
        canvas ? canvas.background : '#FFFFF'
    )

    const handleColorChange = (color, event) => {
        let value = color.hex
        setFillColor(value)
        onColorChange({ canvas, value })
    }

    return (
        <>
            <ColorButton
                onChange={handleColorChange}
                currentColor={fillColor}
            />
        </>
    )
}
